// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueBus from 'vue-bus'
import Routers from './router'
import App from './App'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import * as echarts from 'echarts'

// import preview
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import moment from "moment"
import md5 from 'js-md5'

import api from './api/index'
import store from './store/index'

// import js
import './assets/js/jquery.js'
import './assets/js/sidebar.js'
import common from './assets/js/common.js'
import socket from './assets/js/socket.js'
import exports from './assets/js/exports.js'

// import css
import './assets/css/animate.css'
import './assets/css/layout.css'
import './assets/css/custom.css'
import './assets/css/style.css'

Vue.use(VueBus);
Vue.use(VueRouter);

Vue.use(ViewUI, {
    transfer: true,
});

Vue.prototype.$echarts = echarts;

Vue.use(preview);

Vue.prototype.$video = Video;

Vue.prototype.$moment = moment;
Vue.prototype.$md5 = md5;

Vue.use(api);
Vue.prototype.$api = api;
Vue.prototype.$common = common;
Vue.prototype.$socket = socket;
Vue.prototype.$exports = exports;

// The routing configuration
// const RouterConfig = {
//   routes: Routers
// };

// 修复连续跳转两次路由的报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
};

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return VueRouterReplace.call(this, location).catch(err => err)
};


Vue.config.productionTip = false;

/* eslint-disable no-new */

window.vue = new Vue({
    el: '#app',
    router: Routers,
    api,
    store,
    render: h => h(App),
});

/* LoadingBar */
Routers.beforeEach((to, from, next) => {
    // 路由改变修改页面Title
    if (to.meta.title) {
        document.title = to.meta.title
    }
    ViewUI.LoadingBar.start();
    next();
});
Routers.afterEach(route => {
    ViewUI.LoadingBar.finish();
});



// WEBPACK FOOTER //
// ./src/main.js